import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7f7fa41a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }

import { ref, computed } from "vue";
import { useAuthStore } from "@/store/auth/login";

import InnerPageLayout from "@/widgets/layouts/InnerPageLayout.vue";
import TopTraficPlanPanel from "@/entities/analytics/trafic_plan/panels/TopTraficPlanPanel.vue";
import PlanTraficCreateForm from "@/entities/analytics/trafic_plan/forms/PlanTraficCreateForm.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TraficPlanPage',
  setup(__props) {

const isLoading = ref(false);
const createFormRef = ref(null);
const authStore = useAuthStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:edit"],
    ["analytics:edit"],
    ["campaign:read", "campaign:edit", "system:read"]
  );
});

const isDeniedSave = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:edit"],
    ["analytics:edit"],
    ["campaign:read", "campaign:edit", "system:read"]
  );
});

const createTraficPlan = () => {
  if (createFormRef.value) createFormRef.value.createTraficPlan();
};

const setLoading = (value: boolean) => {
  isLoading.value = value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnerPageLayout, null, {
    default: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(TopTraficPlanPanel, {
            "is-button-disabled": isDeniedSave.value,
            isLoading: isLoading.value,
            onCreateTraficPlan: createTraficPlan
          }, null, 8, ["is-button-disabled", "isLoading"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(PlanTraficCreateForm, {
              isLoading: isLoading.value,
              onSetLoading: setLoading,
              ref_key: "createFormRef",
              ref: createFormRef
            }, null, 8, ["isLoading"])
          ])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})